import { Sidebar, SidebarContent, SidebarRail } from "@/components/ui/sidebar";
import { NavGroup } from "@/components/layouts/nav-group";
import { applicantSidebarData } from "./data/applicant-sidebar-data";

export function ApplicantSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" variant="sidebar" {...props}>
      <SidebarContent>
        {applicantSidebarData.navGroups.map((props, index) => (
          <NavGroup key={index} {...props} />
        ))}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
